module.exports = __webpack_public_path__ + "static/grick-dcf07b7ab44e1df28d58753b6dd7d448.jpg";